import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import {
  fireBulkConfirmNoThanksClicked,
  fireBulkConfirmPopupViewed,
  fireBulkConfirmReviewClicked,
} from '~/posthogs/events';
import AnimatedCheckCircle from '../../shared/AnimatedCheckCircle';
import ConfirmPopup from '../../shared/ConfirmPopup';

export const ConfirmCandidateAnotherJobPopup = ({
  show,
  candidate,
  officeId,
  job,
  shiftId,
  offerId,
  hasPendingJobs,
  onClose,
}) => {
  const navigate = useNavigate();

  // The candidate here IS the professional — this popup is about a single person, so
  // professional_id and candidate_id carry the same id. shiftId/offerId describe the
  // shift and offer that were just confirmed and triggered the popup (GOTU-4815).
  const eventContext = {
    professionalId: candidate?.id,
    candidateId: candidate?.id,
    shiftId,
    offerId,
  };

  useEffect(() => {
    if (show && candidate?.id) {
      fireBulkConfirmPopupViewed({
        professionalId: candidate.id,
        candidateId: candidate.id,
        shiftId,
        offerId,
      });
    }
  }, [show, candidate?.id, shiftId, offerId]);

  if (!show || !job || !candidate) {
    return null;
  }

  return (
    <ConfirmPopup
      Icon={() => (
        <div style={{ marginBottom: 20 }}>
          <AnimatedCheckCircle />
        </div>
      )}
      title={`Candidate Confirmed for ${job?.local_date}!`}
      description={
        <span>
          {candidate?.full_name} has also applied to another shift at your office. Would you like to
          review their application?
        </span>
      }
      rightButtonAction={() => {
        fireBulkConfirmReviewClicked(eventContext);
        navigate(`/offices/${officeId}/candidates/${candidate?.id}/jobs`);
        onClose();
      }}
      rightButtonText="Review"
      leftButtonText="No Thanks"
      leftButtonAction={() => {
        fireBulkConfirmNoThanksClicked(eventContext);
        onClose();
        navigate(`/dashboard/jobs/${hasPendingJobs ? 'pending' : 'scheduled'}`);
      }}
    />
  );
};
